var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVppaOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 76 98",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1141,-578)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,197.157,-1135.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vppa",
    transform: "matrix(1,0,0,1,1.18587,6.48236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.175094,0,0,0.0989332,740.743,818.069)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-1.13769e-16,1.31825e-16,-1,2163.81,2415.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1247.42,1466.25L1247.42,963.294L864.121,963.294L864.121,1363.6L966.649,1466.25L1247.42,1466.25",
    style: {
      fill: "white",
      stroke: "rgb(255,185,52)",
      strokeWidth: "21.7px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-5.6886,0.0330227,-0.0359563,-5.34556,6811.1,2927.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.946,375.225L983.944,357.152L967.825,356.885M967.8,357.001L983.903,375.225",
    style: {
      fill: "rgb(255,185,52)",
      stroke: "rgb(255,185,52)",
      strokeWidth: "1.97px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.487758,0,0,0.256029,751.301,567.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(54.3346,0,0,54.3346,331.364,1433.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.298,-0.051C0.354,-0.053 0.392,-0.074 0.414,-0.112C0.425,-0.131 0.43,-0.154 0.43,-0.18C0.43,-0.22 0.415,-0.251 0.385,-0.272C0.368,-0.285 0.339,-0.297 0.298,-0.308L0.298,-0.051ZM0.133,-0.522C0.133,-0.49 0.143,-0.465 0.165,-0.446C0.186,-0.428 0.215,-0.415 0.251,-0.408L0.251,-0.638C0.208,-0.636 0.178,-0.623 0.16,-0.599C0.142,-0.574 0.133,-0.549 0.133,-0.522ZM0.045,-0.516C0.045,-0.566 0.063,-0.61 0.099,-0.65C0.136,-0.69 0.187,-0.71 0.252,-0.71L0.252,-0.775L0.298,-0.775L0.298,-0.711C0.363,-0.707 0.413,-0.688 0.448,-0.654C0.482,-0.62 0.5,-0.576 0.502,-0.521L0.417,-0.521C0.414,-0.545 0.408,-0.567 0.396,-0.584C0.376,-0.617 0.343,-0.635 0.298,-0.636L0.298,-0.399C0.374,-0.378 0.425,-0.358 0.452,-0.339C0.496,-0.309 0.518,-0.264 0.518,-0.204C0.518,-0.117 0.49,-0.056 0.434,-0.019C0.402,0.001 0.357,0.014 0.298,0.021L0.298,0.116L0.252,0.116L0.252,0.021C0.157,0.015 0.093,-0.019 0.059,-0.08C0.041,-0.112 0.031,-0.157 0.031,-0.213L0.118,-0.213C0.12,-0.168 0.127,-0.136 0.139,-0.115C0.159,-0.078 0.196,-0.058 0.251,-0.053L0.251,-0.319C0.181,-0.333 0.129,-0.355 0.095,-0.386C0.062,-0.417 0.045,-0.461 0.045,-0.516Z",
    style: {
      fill: "rgb(255,185,52)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30587,-0.0394861,-1.03593,0.782436,253.86,883.852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.91,111.01L603.521,85.276",
    style: {
      fill: "none",
      stroke: "rgb(255,185,52)",
      strokeWidth: "3.99px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.314198,0,0,0.164926,879.656,668.772)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(73.4524,0,0,73.4524,116.953,1733.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.378,-0.737C0.469,-0.737 0.54,-0.713 0.59,-0.665C0.64,-0.617 0.668,-0.563 0.673,-0.502L0.579,-0.502C0.568,-0.548 0.546,-0.585 0.514,-0.612C0.482,-0.639 0.437,-0.652 0.379,-0.652C0.309,-0.652 0.252,-0.628 0.208,-0.578C0.165,-0.528 0.143,-0.452 0.143,-0.35C0.143,-0.266 0.163,-0.198 0.202,-0.145C0.241,-0.093 0.3,-0.067 0.377,-0.067C0.449,-0.067 0.504,-0.094 0.541,-0.149C0.561,-0.178 0.576,-0.216 0.585,-0.264L0.68,-0.264C0.672,-0.188 0.644,-0.125 0.596,-0.074C0.539,-0.012 0.462,0.019 0.366,0.019C0.282,0.019 0.212,-0.007 0.156,-0.057C0.081,-0.124 0.044,-0.227 0.044,-0.366C0.044,-0.472 0.072,-0.559 0.128,-0.626C0.188,-0.7 0.272,-0.737 0.378,-0.737Z",
    style: {
      fill: "rgb(255,185,52)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(73.4524,0,0,73.4524,169.998,1733.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.386,-0.737C0.512,-0.737 0.606,-0.696 0.667,-0.615C0.715,-0.551 0.738,-0.47 0.738,-0.371C0.738,-0.264 0.711,-0.175 0.657,-0.104C0.593,-0.021 0.502,0.021 0.384,0.021C0.273,0.021 0.187,-0.015 0.124,-0.088C0.067,-0.159 0.039,-0.248 0.039,-0.355C0.039,-0.452 0.063,-0.535 0.111,-0.604C0.173,-0.693 0.265,-0.737 0.386,-0.737ZM0.396,-0.066C0.481,-0.066 0.543,-0.097 0.581,-0.158C0.62,-0.219 0.639,-0.29 0.639,-0.37C0.639,-0.454 0.617,-0.522 0.573,-0.573C0.528,-0.625 0.468,-0.65 0.392,-0.65C0.317,-0.65 0.257,-0.625 0.21,-0.574C0.163,-0.523 0.14,-0.448 0.14,-0.349C0.14,-0.269 0.16,-0.202 0.2,-0.148C0.24,-0.093 0.305,-0.066 0.396,-0.066Z",
    style: {
      fill: "rgb(255,185,52)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(73.4524,0,0,73.4524,227.132,1733.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.031,-0C0.035,-0.06 0.047,-0.113 0.069,-0.157C0.09,-0.202 0.132,-0.242 0.195,-0.279L0.289,-0.333C0.331,-0.357 0.361,-0.378 0.377,-0.396C0.404,-0.423 0.417,-0.453 0.417,-0.488C0.417,-0.529 0.405,-0.561 0.381,-0.585C0.356,-0.609 0.324,-0.621 0.283,-0.621C0.223,-0.621 0.181,-0.598 0.158,-0.553C0.146,-0.528 0.139,-0.494 0.138,-0.451L0.048,-0.451C0.049,-0.512 0.061,-0.562 0.082,-0.6C0.12,-0.668 0.187,-0.702 0.284,-0.702C0.364,-0.702 0.422,-0.68 0.459,-0.637C0.496,-0.593 0.515,-0.545 0.515,-0.492C0.515,-0.436 0.495,-0.388 0.456,-0.349C0.433,-0.326 0.392,-0.298 0.333,-0.265L0.266,-0.228C0.234,-0.21 0.209,-0.193 0.191,-0.177C0.158,-0.149 0.138,-0.118 0.129,-0.083L0.511,-0.083L0.511,-0L0.031,-0Z",
    style: {
      fill: "rgb(255,185,52)",
      fillRule: "nonzero"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVppaOutline);
export default __webpack_public_path__ + "static/media/vppaOutline.ba85f86a9ff03a8395550b86f608b192.svg";
export { ForwardRef as ReactComponent };